<template>
  <div v-if="drawComponent" class="cabinet-root-wrapper">
    <div class="row" v-if="showForm">
      <template v-if="fullLayout">
        <h1><a @click="$router.go(-1)" style="color: #61b06c;" title="Go back"><i class="fas fa-arrow-circle-left"></i></a> {{ object.name }}</h1>
        <div class="tabbable">
          <!-- Admin view -->
          <ul class="nav nav-tabs nav-tabs-top">
            <li class="active"><a href="#top-tab0" ref="toptab0" @click="storeHash" data-toggle="tab">Dashboard</a></li>
            <li><a href="#top-tab1" ref="toptab1" @click="storeHash" data-toggle="tab">Available Units</a></li>
            <li><a href="#top-tab2" ref="toptab2" @click="storeHash" data-toggle="tab">Sold Units</a></li>
            <li><a href="#top-tab3" ref="toptab3" @click="storeHash" data-toggle="tab">Documents</a></li>
            <li><a href="#top-tab4" ref="toptab4" @click="redrawMap()" data-toggle="tab">Geo Map</a></li>
            <li><a href="#top-tab5" ref="toptab5" @click="storeHash" data-toggle="tab">Media Gallery</a></li>
            <li><a href="#top-tab6" ref="toptab6" @click="storeHash" data-toggle="tab">Intranet Chat</a></li>
          </ul>

          <div class="tab-content">
            <div id="top-tab0" class="tab-pane active">
              <div class="col-sm-12 col-md-12">
                <form @submit.prevent="saveData()">
                  <panel :title='object.name'>
                    <div slot="headingElements" v-if="_can('updateProject')">
                      <div class="pull-right">
                        <button v-if="mode.readonly" @click.prevent="() => { mode.readonly = false }" class="btn btn-primary btn-ladda">EDIT PROJECT DATA</button>
                        <template v-else-if="!mode.readonly">
                          <button @click.prevent="saveData()" class="btn btn-primary btn-ladda mr-10">SAVE DATA</button>
                          <button @click.prevent="() => { mode.readonly = true; refreshFromServer() }" class="btn btn-default btn-ladda mr-10">CANCEL</button>
                        </template>
                        <div class="btn-group ml-5">
                          <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false">{{ currentLanguage.toUpperCase() }} <span class="caret"></span></button>
                          <ul class="dropdown-menu dropdown-menu-right">
                            <li v-for="(item, idx) in config.languages" :key="idx" :class="{'active': item.code === currentLanguage}"><a @click.prevent=" currentLanguage = item.code ">{{ item.code.toUpperCase() }}</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class='col-sm-6'>
                        <div class="row">
                          <div class="col-sm-6">
                            <template v-for="(item, idx) in config.languages">
                              <div class="form-group" :class="{'has-error': errors.has('location') }" v-show="currentLanguage === item.code" :key="idx">
                                <label class="control-label">Name:</label>
                                <input type="text" v-model="object['name' + (item.code !== config.defaultLanguage ? '_' + item.code : '')]" :title="'Project name' + (item.code !== config.defaultLanguage ? ' (' + item.code + ')' : '')" placeholder="Project name" :readonly="mode.readonly" class="form-control"/>
                              </div>
                            </template>
                          </div>
                          <div class="col-sm-3">
                            <div class="form-group" :class="{'has-error': errors.has('budget') }">
                              <label class="control-label">Lat:</label>
                              <input type="text" v-model="object.latitude" placeholder="Latitude" :readonly="mode.readonly" class="form-control"/>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div class="form-group" :class="{'has-error': errors.has('budget') }">
                              <label class="control-label">Lon:</label>
                              <input type="text" v-model="object.longitude" placeholder="Longitude" :readonly="mode.readonly" class="form-control"/>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <template v-for="(item, idx) in config.languages">
                              <div class="form-group" :class="{'has-error': errors.has('location') }" v-show="currentLanguage === item.code" :key="idx">
                                <label class="control-label">Address:</label>
                                <input type="text" v-model="object['address' + (item.code !== config.defaultLanguage ? '_' + item.code : '')]" :title="'Address' + (item.code !== config.defaultLanguage ? ' (' + item.code + ')' : '')" placeholder="Address" :readonly="mode.readonly" class="form-control"/>
                              </div>
                            </template>
                          </div>
                          <div class="col-sm-3">
                            <div class="form-group" :class="{'has-error': errors.has('budget') }">
                              <label class="control-label">ZIP:</label>
                              <input type="text" v-model="object.zip" placeholder="ZIP" :readonly="mode.readonly" class="form-control"/>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div class="form-group" :class="{'has-error': errors.has('budget') }">
                              <label class="control-label">City:</label>
                              <input type="text" v-model="object.city" placeholder="City" :readonly="mode.readonly" class="form-control"/>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group" :class="{'has-error': errors.has('computedSum') }">
                              <label class="control-label">Youtube URL:</label>
                              <input type="text" v-model="object.youtube_url" placeholder="Youtube URL" :readonly="mode.readonly" class="form-control"/>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <label class="control-label">Transfer tax:</label>
                            <div class="input-group" :class="{'has-error': errors.has('computedSum') }">
                              <input type="text" v-model="object.transfer_tax" placeholder="Transfer Tax" :readonly="mode.readonly" class="form-control"/>
                              <span class="input-group-addon">%</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-4 mt-5" v-if="_can('updateProject')">
                            <label class="control-label valign-middle mr-10">Public</label>
                            <toggle-button :value="!!object.is_public" :readonly="mode.readonly" :sync="true" :labels="true" @change="changePublicProject"/>
                          </div>
                          <div class="col-sm-4 mt-5" v-if="_can('updateProject')">
                            <label class="control-label valign-middle mr-10">Active</label>
                            <toggle-button :value="object.status === 1" :readonly="mode.readonly" :sync="true" :labels="true" @change="changeActiveProject"/>
                          </div>
                          <div class="col-sm-4 mt-5" v-if="_can('updateProject')">
                            <label class="control-label valign-middle mr-10">Dashboard</label>
                            <toggle-button :value="object.on_dashboard === 1" :readonly="mode.readonly" :sync="true" :labels="true" @change="changeDashboardProject"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="tabbable">
                          <ul class="nav nav-tabs nav-tabs-top">
                            <li class="active"><a href="#ctop-tab0" data-toggle="tab">Details</a></li>
                            <li><a href="#ctop-tab1" data-toggle="tab">More info</a></li>
                            <li><a href="#ctop-tab2" data-toggle="tab">Equipment</a></li>
                            <li><a href="#ctop-tab3" data-toggle="tab">Other info</a></li>
                          </ul>

                          <div class="tab-content">
                            <div id="ctop-tab0" class="tab-pane active">
                              <div class="row">
                                <div class="col-sm-12">
                                  <template v-for="(item, idx) in config.languages">
                                    <div class="form-group" :class="{'has-error': errors.has('location') }" v-show="currentLanguage === item.code" :key="idx">
                                      <textarea rows="10" v-model="object['details' + (item.code !== config.defaultLanguage ? '_' + item.code : '')]" :title="'Details' + (item.code !== config.defaultLanguage ? ' (' + item.code + ')' : '')" placeholder="Details" :readonly="mode.readonly" class="form-control"></textarea>
                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>
                            <div id="ctop-tab1" class="tab-pane">
                              <div class="row">
                                <div class="col-sm-12">
                                  <template v-for="(item, idx) in config.languages">
                                    <div class="form-group" :class="{'has-error': errors.has('location') }" v-show="currentLanguage === item.code" :key="idx">
                                      <textarea rows="10" v-model="object['more' + (item.code !== config.defaultLanguage ? '_' + item.code : '')]" :title="'More info' + (item.code !== config.defaultLanguage ? ' (' + item.code + ')' : '')" placeholder="More info" :readonly="mode.readonly" class="form-control"></textarea>
                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>

                            <div id="ctop-tab2" class="tab-pane">
                              <div class="row">
                                <div class="col-sm-12">
                                  <template v-for="(item, idx) in config.languages">
                                    <div class="form-group" :class="{'has-error': errors.has('location') }" v-show="currentLanguage === item.code" :key="idx">
                                      <textarea rows="10" v-model="object['equipment' + (item.code !== config.defaultLanguage ? '_' + item.code : '')]" :title="'Equipment' + (item.code !== config.defaultLanguage ? ' (' + item.code + ')' : '')" placeholder="Equipment" :readonly="mode.readonly" class="form-control"></textarea>
                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>

                            <div id="ctop-tab3" class="tab-pane">
                              <div class="row">
                                <div class="col-sm-12">
                                  <template v-for="(item, idx) in config.languages">
                                    <div class="form-group" :class="{'has-error': errors.has('location') }" v-show="currentLanguage === item.code" :key="idx">
                                      <textarea rows="10" v-model="object['other' + (item.code !== config.defaultLanguage ? '_' + item.code : '')]" :title="'Other info' + (item.code !== config.defaultLanguage ? ' (' + item.code + ')' : '')" placeholder="Other info" :readonly="mode.readonly" class="form-control"></textarea>
                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </panel>
                </form>
                <!-- project gallery -->
                <!-- project gallery -->
              </div>
            </div>

            <div id="top-tab1" class="tab-pane">
              <div class="col-sm-12">
                <!-- already added apartments -->
                <!-- aparment add form/modal -->
                <modal id="apartmentAddForm" :size="'lg'" v-show="addApartmentMode">
                  <div slot="header">
                    <button type="button" class="close" @click.prevent="addApartmentClose()">×</button>
                    <h5 class="modal-title">New apartment</h5>
                  </div>
                  <div slot="body">
                    <apartment-form ref="apartmentForm" :createMode="true" :hide-header="true" :project="object" @created="doneAddApartment" @submitted="addApartment"></apartment-form>
                  </div>
                  <div slot="footer">
                    <button type="button" @click.prevent="addApartmentClose()" class="btn btn-default legitRipple">Cancel</button>
                    <button type="submit" @click.prevent="addApartment()" :disabled="errors.any()" class="btn btn-primary legitRipple">Save changes</button>
                  </div>
                </modal>
                <!-- aparment VIEW/EDIT modal -->
                <modal id="apartmentViewForm" :size="'lg'" v-show="viewApartmentMode && currentApartment">
                  <div slot="header">
                    <button type="button" class="close" @click.prevent="viewApartmentClose()">×</button>
                    <h5 class="modal-title">Apartment #{{currentApartment.data.code}}</h5>
                  </div>
                  <div slot="body">
                    <apartment-form ref="apartmentViewForm" :entity="currentApartment" :createMode="false" :hide-header="true" :project="object" @enterEditMode="enterApartmentEditMode" @updated="doneEditApartment" @submitted="saveApartment"></apartment-form>
                  </div>
                  <div slot="footer">
                    <button type="button" @click.prevent="viewApartmentClose()" class="btn btn-default legitRipple">Cancel</button>
                    <button type="submit" @click.prevent="saveApartment()" :disabled="errors.any()" class="btn btn-primary legitRipple" v-show="apartmentEditMode">Save changes</button>
                  </div>
                </modal>

                <panel :title='"Available units"'>
                  <div slot="headingElements">
                    <div class="pull-right">
                      <a v-show="hasChanges" class="btn btn-warning btn-flat" @click.prevent="saveChanges"><i v-bind:class='{"icon-floppy-disk": !savingChanges, "icon-spinner2 spinner": savingChanges}'></i> <span class="text-semibold">Save changes</span></a>
                      <a
                        class="btn btn-flat"
                        :disabled="!canBeChanged()"
                        v-bind:class='{"bg-success": canBeChanged(), "bg-warning btn-disabled": !canBeChanged()}'
                        @click.prevent='addApartmentClick'
                        v-if="_can('createApartment')"
                      >
                        <i class="icon icon-add"></i> <span class="text-semibold"> Add apartment</span>
                      </a>
                    </div>
                    <div v-if="selectedItems.length && _can('createSale')" style="margin-right: 10px;" class="pull-right">
                      <a @click.prevent="$refs.listBlock.flushSelection()" class="btn btn-default btn-flat">Cancel</a>
                      <a @click.prevent="makeOffer" class="btn bg-success btn-flat"> Make offer ({{selectedItems.length}})</a>
                    </div>
                  </div>
                  <apartment-list
                    ref="listBlock"
                    :items="object.apartments.filter((a) => {return a.status === 1})"
                    :columns="{status: true, selection: _can('createSale'), actions: _can('updateProject'), deleteItem: _can('updateProject')}"
                    @itemDelete="deleteApartment"
                    @viewApartmentClick="viewApartmentClick"
                    @setApartmentItemStatus="setApartmentItemStatus"
                    @selectionChanged="selectionChanged">
                  </apartment-list>
                </panel>
              </div>
            </div>

            <div id="top-tab2" class="tab-pane">
              <panel :title='"Sold units"'>
                <apartment-list
                  ref="listBlock2"
                  :items="object.apartments.filter((a) => {return a.status === 3})"
                  :columns="{status: true, selection: false, actions: _can('updateProject'), deleteItem: _can('updateProject')}"
                  @itemDelete="deleteApartment"
                  @viewApartmentClick="viewApartmentClick">
                </apartment-list>
              </panel>
            </div>

            <div id="top-tab3" class="tab-pane">
              <panel :title='"Project public files"'>
                <div class="row">
                  <div>
                    <model-files-list ref="modelFilesList" :files="object.modelFiles" :can-delete-file="_can('updateProject')" :file-slot="{code: 'project-public-files'}" @deleteFile="deleteFile"></model-files-list>
                    <div class="col-sm-3" v-if="_can('updateProject')">
                      <UploadForm
                        :dropzone="true"
                        :dropzoneClearOnUpload="true"
                        :fileSlot="'project-public-files'"
                        accept="*/*"
                        @uploadComplete="docUploadComplete"
                        @uploadError="uploadError"
                        :multiple="true"
                        label="Add document"
                        labelIconClass="icon-add"
                        :showHint="false"
                        :uploadUrl="docUploadUrl"
                      ></UploadForm>
                    </div>
                  </div>
                </div>

                <div slot="footerElements" v-if="galleryEditMode">
                  <div class="pull-right">
                    <button @click.prevent="cancelGalleryEditMode" :disabled="errors.any()" class="btn btn-link legitRipple">Cancel</button>
                    <button type="submit" @click.prevent="saveGalleryData()" :disabled="errors.any()" class="btn btn-primary legitRipple">Save changes</button>
                  </div>
                </div>
              </panel>
            </div>

            <div id="top-tab4" class="tab-pane">
              <div class="tabbable">
                <ul class="nav nav-tabs nav-tabs-top">
                  <li class="active"><a href="#map-tab0" ref="maptab0" @click="switchTab" data-toggle="tab">OpenStreetMap</a></li>
                  <li><a href="#map-tab1" ref="maptab1" @click="switchTab" data-toggle="tab">Google Maps</a></li>
                </ul>
                <div class="tab-content">
                  <div id="map-tab0" class="tab-pane active">
                    <l-map ref="map" style="height: 100%; width: 100%;" :zoom=13 :lat-lng="[object.latitude, object.longitude]" :center="[object.latitude, object.longitude]">
                      <l-tilelayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tilelayer>
                      <l-marker :lat-lng="[object.latitude, object.longitude]"></l-marker>
                    </l-map>
                  </div>
                  <div id="map-tab1" class="tab-pane">
                    <GmapMap
                      :center="{lat: parseFloat(object.latitude), lng: parseFloat(object.longitude)}"
                      :zoom="13"
                      map-type-id="terrain"
                    >
                      <GmapMarker
                        :position="{lat: parseFloat(object.latitude), lng: parseFloat(object.longitude)}"
                        :clickable="true"
                        :draggable="false"
                        @click="center={lat: parseFloat(object.latitude), lng: parseFloat(object.longitude)}"
                      />
                    </GmapMap>
                  </div>
                </div>
              </div>
            </div>

            <div id="top-tab5" class="tab-pane">
              <panel v-if="_is('superAdmin')" :title='"Project Dashboard Picture"'>
                <div class="col-sm-12">
                  <div class="row" id="gallery2" v-if="object.logo">
                    <div class="flexible-item">
                      <div class="thumbnail">
                        <div class="thumb">
                          <a :href="object.logo.fullscale" data-popup="lightbox">
                            <img v-if="object.logo.is_public" :src="object.logo.preview">
                            <img v-if="!object.logo.is_public" v-auth-img="object.logo.preview">
                          </a>
                          <div class="caption-overflow" v-if="_can('updateProject')">
                            <span>
                              <a href="javascript: void(0);" class="btn btn-info btn-sm" @click="removeLogo()">Remove</a>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <UploadForm :dropzone="true" accept="image/*" @uploadComplete="uploadComplete2" @uploadError="uploadError2"></UploadForm>
                  </div>
                </div>
              </panel>
              <panel :title='"Project gallery"' :footerShow="galleryEditMode">
                <div slot="headingElements" v-if="_can('updateProject')">
                  <div class="pull-right">
                    <button v-if="!galleryEditMode" @click.prevent="() => { galleryEditMode = true }" class="btn btn-primary btn-ladda">EDIT PROJECT GALLERY</button>
                    <template v-else-if="galleryEditMode">
                      <button @click.prevent="saveGalleryData()" :disabled="errors.any()" class="btn btn-primary btn-ladda mr-10">SAVE CHANGES</button>
                      <button @click.prevent="cancelGalleryEditMode" class="btn btn-default btn-ladda mr-10">CANCEL</button>
                    </template>
                  </div>
                </div>
                <div class="row" id="gallery" v-if="galleryEditMode">
                  <div class="flexible-item" v-for="(item, idx) in activeImages()" :key="idx">
                    <div class="thumbnail">
                      <div class="thumb">
                        <a :href="item.fullscale" data-popup="lightbox">
                          <img v-if="item.is_public" :src="item.preview">
                          <img v-if="!item.is_public" v-auth-img="item.preview">
                        </a>
                        <div class="caption-overflow" v-if="_can('updateProject') && galleryEditMode">
                        <span>
                          <a href="javascript: void(0);" class="btn btn-info btn-sm" @click="removeImage(item)">Remove</a>
                        </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12" v-if="_can('updateProject') && galleryEditMode">
                    <UploadForm
                      :dropzone="true"
                      :dropzoneClearOnUpload="true"
                      accept="image/*"
                      @uploadComplete="uploadComplete"
                      @uploadError="uploadError"
                      :multiple="true"
                      label="Add photo"
                      labelIconClass="icon-add"
                      :showHint="false"
                    ></UploadForm>
                  </div>
                </div>
                <div id="gallery2" class="row" v-else>
                  <div class="flexible-item" v-for="(item, idx) in activeImages()" :key="idx">
                    <Lightbox v-if="item.is_public" :thumbnail="item.preview" :images="aiClone().map((e)=>{return e.fullscale}).rotate(idx)"></Lightbox>
                  </div>
                </div>
              </panel>
            </div>

            <div id="top-tab6" class="tab-pane">

            </div>
          </div>
        </div>
      </template>
      <template v-else-if="shortLayout">
        <div class="col-sm-12">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-5 control-label">Name</label>
              <div class="col-sm-7">
                <input type="text" readonly :value="project.name" class="form-control form-control-small-height"/>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-5 control-label">Address</label>
              <div class="col-sm-7">
                <input type="text" readonly :value="project.address" class="form-control form-control-small-height"/>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-5 control-label">Apartments</label>
              <div class="col-sm-7">
                <input type="text" readonly :value="project.soldApartments + ' of ' + project.totalApartments" class="form-control form-control-small-height"/>
              </div>
            </div>
          </form>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ToggleButton from 'vue-js-toggle-button/src/Button'

import ProjectService from '@/services/project.service'
import ApartmentService from '@/services/apartment.service'

import Panel from '@/components/_partial/_atomic/panel'
import Modal from '@/components/Modal'
import ApartmentForm from '../apartment/Form'
import UploadForm from '@/components/_partial/UploadForm'
import ApartmentList from '../apartment/_partial/List'
import ModelFilesList from '../sale/_partial/ModelFilesList'
import Lightbox from '@/components/_partial/Lightbox'

import formMixin from '@/helpers/mixins/_formMixin'
import 'leaflet/dist/leaflet.css'

export default {
  name: 'ProjectView',
  components: { Lightbox, ModelFilesList, ApartmentList, UploadForm, ApartmentForm, Panel, Modal, ToggleButton },

  mixins: [formMixin],

  props: {
    'entity': {
      type: Object
    },
    'oid': {
      type: [String, Number]
    },
    'layout': {
      type: String,
      default: 'full'
    }
  },
  data () {
    return {
      id: null,
      object: {},
      images: [],
      idFilter: [],
      currentObject: false,
      localizedFormat: {},
      /** service **/
      service: ProjectService,
      services: {
        'apartment': ApartmentService
      },
      statuses: [],
      systemStatuses: [],
      apartmentStatuses: [],
      apartmentAvailableStatuses: [],
      groupStatuses: [],
      showForm: false,
      mode: {
        hash: false,
        statusMap: {},
        apartmentStatusMap: {},
        resetAfterMount: false,
        readonly: true
      },
      /** **/
      currentApartment: { data: {} },
      selectedItems: [],
      /** **/
      editMode: false,
      galleryEditMode: false,
      /** **/
      addApartmentMode: false,
      viewApartmentMode: false,
      apartmentEditMode: false,
      /** **/
      hasChanges: false,
      savingChanges: false,
      drawComponent: true,
      /** **/
      docUploadUrl: ''
    }
  },

  computed: {
    project: function () {
      if (this.entity) {
        return this.entity
      }
      if (this.object) {
        return this.object
      }
      return {}
    },

    shortLayout: function () {
      return this.layout === 'short'
    },

    fullLayout: function () {
      return this.layout === 'full'
    }
  },

  beforeMount () {
    this.localizedFormat = Vue.config.localizedFormat
    if (this.mode.resetAfterMount) {
      this.reset(true)
    }
    this.mode.apartmentStatusMap = {
      'label-danger': 3,
      'bg-orange-300': 2,
      'label-success': 1
    }
    this.apartmentStatuses = [
      '',
      'Available', // 1
      'Reserved', // 2
      'Sold' // 3
    ]
    for (let i = 1; i < this.apartmentStatuses.length; i++) {
      this.apartmentAvailableStatuses.push(this.apartmentStatuses[i])
    }
    this.mode.statusMap = Vue.config.statusMap
    this.systemStatuses = Vue.config.statuses
    this.groupStatuses = Vue.config.statusGroups['project'] ? Vue.config.statusGroups['project'] : Vue.config.statusGroups['*']
    this.statuses = []
    for (let i = 0; i < this.groupStatuses.length; i++) {
      this.statuses.push(this.systemStatuses[this.groupStatuses[i]])
    }
  },

  watch: {
    '$route': 'flushObjectIfRequired'
  },

  mounted () {
    // let promises = []
    this.reset(true)
    this.refresh()
    this.mode.resetAfterMount = false
  },

  updated () {
    if (this.$route.hash.match(/#top\-tab\d+/i)) {
      let refid = this.$route.hash.replace(/[#\-]/g, '')
      console.log(refid, this.$refs, this.$refs[refid])
      if (this.mode.hash !== false) {
        refid = this.mode.hash.replace(/[#\-]/g, '')
      }
      this.$refs[refid].click()
    }
  },

  methods: {
    switchTab (e) {

    },

    storeHash (e) {
      this.mode.hash = e.target.hash
    },

    redrawMap () {
      window.dispatchEvent(new Event('resize'))
    },

    activeImages () {
      return this.images.filter(img => {
        return !img.isDeleted
      })
    },

    aiClone () {
      return this.activeImages().slice()
    },

    selectionChanged (ids) {
      this.selectedItems = ids
    },

    makeOffer () {
      if (this.selectedItems.length) {
        this.$router.push({ 'name': 'sale.create', params: { apartments: this.selectedItems } })
      } else {
        this.$popup.warning('Select at least one apartment to make offer')
      }
    },

    flushObjectIfRequired () {
      console.log(this.$route)
      if (this.$route.name === 'project.create') {
        this.id = false
        this.mode.resetAfterMount = true
        // this.object = {}
        for (let i in this.service.__itemTemplate) {
          this.object[i] = this.service.__itemTemplate[i]
        }
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
        this.hardReset()
      } else {
        if (this.oid) {
          this.refreshFromServer()
        }
      }
    },

    hardReset () {
      let vm = this
      vm.drawComponent = false
      Vue.nextTick(() => {
        vm.drawComponent = true
        this.makeIdFilter()
        this.object = this.object
      })
    },

    reset (forceItemReset = true) {
      this.hasChanges = false
      if (typeof this.entity === 'object' && this.entity.hasOwnProperty('id')) {
        for (let i in this.entity) {
          if (this.entity.hasOwnProperty(i)) {
            this.object[i] = this.entity[i]
            if (i === 'required_at') {
              this.object.period = this.$moment(this.object[i]).format(Vue.config.localizedFormat.date)
            }
          }
        }
        this.id = this.entity.id
        forceItemReset = false
      }
      this.$emit('reset', forceItemReset)
      if (forceItemReset) {
        this.flushObjectIfRequired()
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
      }
      this.makeIdFilter()
    },

    refreshFromServer () {
      this.service.item(this.oid, result => {
        for (let i in result) {
          if (result.hasOwnProperty(i)) {
            this.object[i] = result[i]
          }
        }
        this.id = this.object.id
        this.$emit('loadObject', this.object)
        this.showForm = true
        this.$emit('shown', this.object)
        //
        this.hardReset()
        if (this.fullLayout) {
          this.docUploadUrl = Vue.config.endpoints.project.attachFiles.replace('{:id}', this.id)
          this.setupGallery()
        }
      })
    },

    refresh (newInstance) {
      if (!this.object.id && this.oid) {
        this.refreshFromServer()
      } else {
        if (newInstance) {
          for (let i in newInstance) {
            if (newInstance.hasOwnProperty(i)) {
              this.object[i] = newInstance[i]
            }
          }
          this.id = this.object.id
          this.$emit('assignObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.hardReset()
        }
        this.showForm = true
        this.$emit('shown', this.object)
      }
      if (this.object.hasOwnProperty('id')) {
        this.id = this.object.id
      }
      if (this.fullLayout) {
        this.docUploadUrl = Vue.config.endpoints.project.attachFiles.replace('{:id}', this.id)
        this.setupGallery()
      }
      this.makeIdFilter()
    },

    setItemStatus (item, status) {
      this.service.update(item, { 'id': item, 'status': status }, result => {
        this.service.item(result.id, newdata => {
          this.refresh(newdata)
          this.hasChanges = true
          this.hasChanges = false
        })
      }, () => {
        this.$popup.warning('Can\'t set item STATUS on server')
      })
    },

    setApartmentItemStatus (item, status) {
      let $vm = this
      this.services['apartment'].update(item, { 'id': item, 'status': status }, result => {
        this.services['apartment'].item(result.id, () => {
          this.reset()
        })
      }, () => {
        $vm.$popup.warning('Can\'t set item STATUS on server')
      })
    },

    saveData () {
      if (this.id) {
        this.service.update(this.id, this.prepareData(this.object), () => {
          this.mode.readonly = true
          this.refreshFromServer()
        })
      } else {
        this.service.create(this.prepareData(this.object), result => {
          for (let i in result) {
            if (result.hasOwnProperty(i)) {
              this.object[i] = result[i]
            }
          }
          this.$router.push('/project/details/' + parseInt(this.object.id))
        })
      }
    },

    saveLogoData () {
      if (this.id) {
        this.service.update(this.id, { 'logo': this.object.logo, 'logo_image_id': this.object.logo_image_id }, (result) => {
          this.mode.readonly = true
          this.object.logo = result.logo
          this.object.logo_image_id = result.logo_image_id
        })
      }
    },

    enterEditMode () {
      this.editMode = true
      this.showForm = false
      this.showForm = true
    },

    cancelEditMode () {
      this.editMode = false
      this.showForm = false
      this.showForm = true
    },

    saveChanges () {
      // let promises = []
      if (this.hasChanges) {
      }
    },

    addApartment () {
      this.$refs.apartmentForm.saveData()
    },

    saveApartment () {
      this.$refs.apartmentViewForm.saveData()
    },

    addApartmentClick () {
      if (this.canBeChanged()) {
        this.addApartmentMode = true
      }
    },

    viewApartmentClick (id) {
      let $vm = this
      if (typeof id === 'object') {
        $vm.currentApartment = id
        $vm.showLoader = false
        $vm.viewApartmentMode = true
      } else {
        $vm.showLoader = true
        this.services['apartment'].item(id, result => {
          $vm.currentApartment = result
          $vm.showLoader = false
          $vm.viewApartmentMode = true
        }, () => {
          $vm.showLoader = false
          $vm.$popup.error('Can\'t load Apartment #' + $vm.$formatter.formatID(id) + ' details')
        })
      }
    },

    addApartmentClose () {
      this.addApartmentMode = false
    },

    deleteApartment (item) {
      let $vm = this
      $vm.$popup.confirm('Are you sure you want to remove this apartment?', 'Apartment delete').then(() => {
        $vm.services['apartment'].drop(item, (result) => {
          $vm.$popup.success('Apartment successfully removed from project').then(() => {
            $vm.reset()
          })
        }, (err) => {
          $vm.$popup.error('Apartment cannot be removed: ' + err)
        })
      })
    },

    viewApartmentClose () {
      this.$refs.apartmentViewForm.cancelEditMode()
      this.viewApartmentMode = false
      this.apartmentEditMode = false
      this.currentApartment = { data: {} }
    },

    enterApartmentEditMode () {
      this.apartmentEditMode = true
    },

    doneAddApartment (e) {
      let $vm = this
      if (e.id) {
        this.addApartmentMode = false
        $vm.refreshFromServer()
        this.$popup.success('Apartment #' + e.data.code + ' successfully added to project.').then(() => {
        })
      } else {
        this.$popup.warning('Something going wrong...')
      }
    },

    doneEditApartment (e) {
      let $vm = this
      if (e.id) {
        this.viewApartmentMode = false
        $vm.refreshFromServer()
        this.$popup.success('Apartment #' + e.data.code + ' successfully saved.').then(() => {
        })
      } else {
        this.$popup.warning('Something going wrong...')
      }
    },

    checkChanges (e) {
      this.hasChanges = true
    },

    prepareData (obj) {
      let result = Object.assign({}, obj)
      result.logo = obj.logo
      result.logo_image_id = obj.logo_image_id
      result.is_public = result.is_public ? 1 : 0
      result.on_dashboard = result.on_dashboard ? 1 : 0
      return result
    },

    canBeChanged () {
      let result = typeof this.object === 'object'
      result = result && this.object.status === 1
      return result
    },

    changePublicProject (event) {
      this.object.is_public = event.value
      if (this.mode.readonly && this._can('updateProject')) {
        this.saveData()
      }
    },

    changeActiveProject (event) {
      this.object.status = event.value ? 1 : 2
      if (this.mode.readonly && this._can('updateProject')) {
        this.saveData()
      }
    },

    changeDashboardProject (event) {
      this.object.on_dashboard = event.value ? 1 : 0
      if (this.mode.readonly && this._can('updateProject')) {
        this.saveData()
      }
    },

    /** invoice can be **/

    /** **/

    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    makeIdFilter () {
      this.idFilter = []
      if (this.object && Array.isArray(this.object.purchaseOrderProducts)) {
        for (let i in this.object.purchaseOrderProducts) {
          this.idFilter.push(this.object.purchaseOrderProducts[i].product_id)
        }
      }
    },

    /** action methods **/

    uploadComplete (file) {
      this.galleryEditMode = true
      this.$logger.log('uploadComplete', file)

      let image = file.uploaded.image || null
      if (!image) {
        this.$popup.warning('Uploaded file is not an image')
        return
      }

      image.isNew = true
      this.images.push(image)
      this.$forceUpdate()
    },

    docUploadComplete (file) {
      this.$logger.log('docUploadComplete', file)
      this.object.modelFiles.push(file.uploaded)
      this.object.files.push(file.uploaded.file)
      this.$refs.modelFilesList.$forceUpdate()
      this.$forceUpdate()
    },

    uploadError (file) {
      this.$logger.log('uploadError', file)
      this.$popup.warning('Failed to upload file')
    },

    setupGallery () {
      this.images = []
      if (this.object && this.object.images) {
        this.object.images.forEach(item => {
          this.images.push(item)
        })
      }
    },

    removeImage (image) {
      this.galleryEditMode = true
      if (image.isNew) {
        this.images = this.images.filter(img => {
          return img !== image
        })
      } else {
        // console.log(this.images.indexOf(image))
        image.isDeleted = true
        this.images.splice(this.images.indexOf(image), 1, image)
      }
      this.$forceUpdate()
    },

    deleteFile (fileId) {
      this.$popup.confirm('Are you sure to delete this file?').then(() => {
        this.service.detachFiles(this.object.id, [fileId], () => {
          this.$popup.success('File removed successfully')
          this.object.modelFiles = this.object.modelFiles.filter((f) => {
            return parseInt(f.file.id) !== parseInt(fileId)
          })
          this.object.files = this.object.files.filter((f) => {
            return parseInt(f.id) !== parseInt(fileId)
          })
          this.$forceUpdate()
        }, () => {
          this.$popup.error('File couldn\'t be deleted')
        })
      })
    },

    saveGalleryData () {
      const imagesIds = this.activeImages().map(img => {
        return img.id
      })
      this.service.attachImages(this.id, { imagesIds: imagesIds }, () => {
        this.galleryEditMode = false
        this.refreshFromServer()
        this.$forceUpdate()
      })
    },

    cancelGalleryEditMode () {
      this.images = this.images.map(img => {
        img.isDeleted = false
        return img
      })

      this.images = this.images.filter(img => {
        return !img.isNew
      })

      this.galleryEditMode = false
    },

    /** action methods **/
    setLogo (image) {
      this.object = Object.assign(this.object, {
        logo: image || null
      })
      this.object.logo_image_id = image.id || null
    },

    removeLogo () {
      this.object.logo = null
      this.object.logo_image_id = null
      this.saveLogoData()
    },

    uploadComplete2 (file) {
      this.$logger.log('uploadComplete', file)
      this.setLogo(file.uploaded.image || null)
      this.saveLogoData()
    },

    uploadError2 (file) {
      this.$logger.log('uploadError', file)
      this.$popup.warning('Failed to upload file')
    }
  },
  beforeDestroy () {
    this.object = {}
  }
}
</script>

<style lang="scss">
  #gallery2 {
    .flexible-item {
      display: flex;
      /* width: 20%; */
      -webkit-box-flex: 0;
      -ms-flex: 0 1 20%;
      flex: 0 0 30%;
      position: relative;
      margin-right: 10px;
      > div {
        display: flex;
        flex: 1 0 100%;
      }
    }

    a.lightbox__thumbnail {
      margin-right: 10px;
      margin-bottom: 10px;
      flex: 1 0 100%;
      img {
        width: 100%;
        height: 100%;
        max-height: 150px;
        object-fit: contain;
        object-position: 50% 50%;
        flex: 0 0 100%;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .logo-image img {
    max-height: 112px;
    min-height: 112px;
    max-width: 100%;
    width: auto;
  }

  #gallery, #gallery2 {

    display: flex;
    width: 100%;
    flex-flow: row wrap;
    justify-content: flex-start;

    .flexible-item {
      display: flex;
      /* width: 20%; */
      -webkit-box-flex: 0;
      -ms-flex: 0 1 20%;
      flex: 0 0 30%;
      position: relative;
      margin-right: 10px;
      > div {
        display: flex;
      }
    }

    .logo-image img {
      max-height: 250px;
      min-height: 250px;
      max-width: 100%;
      width: auto;
    }

    .thumbnail {
      /* max-width: 200px; */
      /* max-height: 200px; */
      margin-top: 10px;
      flex: 1 0 100%;
      /* height: 100%; */
      /* width: 100%; */

      .thumb {
        width: 100%;
        height: 100%;

        > a {
          display: flex;
          height: 100%;
          width: 100%;
          position: relative;
          vertical-align: middle;

          img {
            width: 100%;
            height: 100%;
            max-height: 150px;
            /* float: left; */
            object-fit: contain;
            object-position: 50% 50%;
            flex: 0 0 100%;
          }

        }
      }

      .file-icon {
        width: 100%;
        min-height: 100px;
        height: 100%;
        display: block;
      }

      .caption-overflow {

        .file-title {
          display: block;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: unset;
          position: relative;
          white-space: nowrap;
          top: 10px;
        }

      }
    }
  }

  // Should not be nested like this, but for now - this is the most clear way to distinguish problems
  .cabinet-root-wrapper {
    min-height: 100%;
    height:auto !important;
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .row {
      flex: 1;
      display: flex;
      flex-direction: column;
      .tabbable {
        flex: 1;
        display: flex;
        flex-direction: column;
        .tab-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          .tab-pane.active {
            flex: 1;
            display: flex;
            flex-direction: column;
            .tabbable {
              flex: 1;
            }
          }
        }
      }
    }
  }

// .vue-map-container {
//     min-height: 500px;
//   flex: 1;
// }
.vue2leaflet-map {
  min-height: 500px;
  flex: 1;
}
.vue-map-container {
  flex: 1;
  min-height: 500px;

}
</style>
